import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 16.987a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V8.315a1.5 1.5 0 0 0-.488-1.106l-7.5-6.816a1.5 1.5 0 0 0-2.024 0l-7.5 6.816A1.5 1.5 0 0 0 0 8.315zm1.5-8.672L9 1.5l7.5 6.815v8.672h-15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }